import React from 'react';
import PropTypes from 'prop-types';
import { t } from 'i18next';
import { format } from 'date-fns';
import {
  SummaryTitle,
  Table,
  TableCell,
  SummaryContainer,
  CellLabel,
  TableTitle,
  CellValue,
} from '../css';

const PickupDetails = ({ data }) => (
  <SummaryContainer>
    <SummaryTitle>{t('PickupDetails')}</SummaryTitle>
    <Table>
      <TableTitle>{t('General')}</TableTitle>
      <TableCell>
        <CellLabel>{t('DroppingFreightOffTitle')}</CellLabel>
        <CellValue>{data.droppingFreightOff ? t('Yes') : t('No')}</CellValue>
      </TableCell>
      <TableCell>
        <CellLabel>{t('RegularScheduledPickupTitle')}</CellLabel>
        <CellValue>{data.hasRegularPickups ? t('Yes') : t('No')}</CellValue>
      </TableCell>
      <TableCell>
        <CellLabel>{t('PickupDate')}</CellLabel>
        <CellValue>
          {data.pickupDate ? format(data.pickupDate, t('DATE_FORMAT_PATTERN')) : '-'}
        </CellValue>
      </TableCell>
      <TableCell>
        <CellLabel>{t('ReadyTime')}</CellLabel>
        <CellValue>{format(data.readyTime, t('TIME_FORMAT_PATTERN'))}</CellValue>
      </TableCell>
      <TableCell>
        <CellLabel>{t('ClosingTime')}</CellLabel>
        <CellValue>{format(data.closingTime, t('TIME_FORMAT_PATTERN'))}</CellValue>
      </TableCell>
    </Table>

    <Table>
      <TableTitle>{t('AdditionalNotes')}</TableTitle>
      <TableCell>
        <CellValue>
          {data.notes.map((note, index) => (
            <React.Fragment key={index}>
              {note}
              <br />
            </React.Fragment>
          ))}
        </CellValue>
      </TableCell>
    </Table>
  </SummaryContainer>
);

PickupDetails.propTypes = {
  data: PropTypes.shape({
    droppingFreightOff: PropTypes.bool,
    hasRegularPickups: PropTypes.bool,
    pickupDate: PropTypes.string,
    readyTime: PropTypes.string,
    closingTime: PropTypes.string,
    notes: PropTypes.arrayOf(PropTypes.string),
  }),
};

export default PickupDetails;
